import React from 'react';
import { IJobPaymentError, ITeacher } from 'models';
import { PillButton, Row, Stack, Text, Title } from 'library/ui';
import JobTemplateListContent from 'parent-portal/forms/components/pages/SelectTemplatePage/JobTemplateListContent';
import { useUserContext } from 'UserContext';
import { convertPreferredSitterObject } from 'parent-portal/forms/components/pages/ProviderPreferencesPage/preferredWorkersApi';
import { submitOngoingRequest } from 'parent-portal/forms/JobRequestSubmission';
import JobPaymentErrorDisplay from 'parent-portal/forms/components/JobPaymentErrorDisplay';

export default function InviteWorkersToJob({
    selectedWorkers,
    goBack,
    onSubmit,
}: {
    selectedWorkers: ITeacher[];
    goBack: () => void;
    onSubmit: () => void;
}) {
    const [selectedJob, setSelectedJob] = React.useState<number>();
    const [error, setError] = React.useState('');
    const [paymentError, setPaymentError] = React.useState<IJobPaymentError>();
    const { user } = useUserContext();
    const [address, setAddress] = React.useState<number | null>(user?.address[0]?.id || null);
    const [loading, setLoading] = React.useState(false);

    function submit() {
        setError('');
        setPaymentError(undefined);
        if (!selectedJob) return;
        setLoading(true);
        submitOngoingRequest({ preferred_sitters: convertPreferredSitterObject([], [], selectedWorkers) }, selectedJob)
            .then(onSubmit)
            .catch((error) => {
                const errorText = error?.errors?.length ? error.errors.map((x: string) => x).join(' ') : undefined;
                if (errorText) {
                    setError(
                        errorText ||
                            'There was an error inviting the user to this job. Try again or reach out to support',
                    );
                } else if (error?.payment) {
                    setPaymentError(error?.payment);
                } else {
                    setError('There was an error inviting the user to this job. Try again or reach out to support');
                }
            })
            .finally(() => setLoading(false));
    }

    return (
        <Stack gap="md">
            <Title size="h2">Invite Teachers to existing job</Title>
            <Text weight="semibold">
                Selected teachers: <Text weight="regular">{selectedWorkers.map((w) => w.name).join(', ')}</Text>
            </Text>
            <JobTemplateListContent
                address={address}
                setAddress={setAddress}
                emptyText="Sorry, we couldn't find any open jobs for this location."
                selectedJobId={selectedJob}
                setSelectedJobId={setSelectedJob}
                openJobsOnly
            />
            {error ? (
                <Text size="sm" tone="error">
                    {error}
                </Text>
            ) : null}
            {paymentError ? <JobPaymentErrorDisplay paymentError={paymentError} /> : null}
            <Row gap="sm" justify="end" fullWidth>
                <PillButton variant="secondary" onClick={goBack}>
                    Back
                </PillButton>
                <PillButton disabled={!selectedJob || loading} onClick={submit}>
                    {loading ? 'Inviting…' : 'Invite'}
                </PillButton>
            </Row>
        </Stack>
    );
}
